














import Vue from 'vue'
import Component from 'vue-class-component'
import { multiplyKey } from './../custom-flows'

@Component({})
export default class Primary extends Vue {
  value = 7;

  public async doTheThingZhuLi() {
    const result: number = await this.$flows.start(
      multiplyKey, //The type of this FlowKey allows TypeScript to infer the return and payload types
      this.value
    );
    if (result != null) {
      this.value = result;
    }
  }
}
